var render = function render(_c,_vm){return _c('div',{class:['note', `is-${_vm.props.type}`]},[(_vm.props.label)?_c('span',{staticClass:"note-label"},[_vm._v(_vm._s(_vm.props.label === true ? _vm.props.type : _vm.props.label)+":")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }